<template>

        <TransitionRoot as="template" :show="openit">
          
          <Dialog as="div" class="relative z-10" @close="closeit">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
              <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
              <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                  <DialogPanel class="relative transform overflow-hidden rounded-lg bg-secondary px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                    <div>
                      <div class="mt-3 text-center sm:mt-5">
                        <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">New Link</DialogTitle>


                        <div class="mt-2 text-start">
                          <form @submit.prevent="emittr">
                            <div class="mb-4">
                              <label class="block text-gray-700 font-medium mb-2 " for="name">
                                Name
                              </label>
                              <input v-model="form.title" class="form-input w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-400 sm:text-sm sm:leading-6" id="name" type="text" required>
                            </div>
                            <div class="mb-4">
                              <label class="block text-gray-700 font-medium mb-2" for="type">
                                Type
                              </label>
                              <input v-model="form.type" class="form-input w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-400 sm:text-sm sm:leading-6" id="type" type="text" required>
                            </div>
                            <div class="mb-4">
                              <label class="block text-gray-700 font-medium mb-2" for="link">
                                Link
                              </label>
                              <input v-model="form.link" class="form-input w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-400 sm:text-sm sm:leading-6" id="link" type="text" required>
                            </div>
                            <button class="rounded bg-primary-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-primary-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600" type="submit">Add Link</button>
                            <!-- <button class="bg-primary-600 text-white" type="submit">Submit</button> -->
                          </form>
                        </div>
                      </div>
                    </div>

                  </DialogPanel>
                </TransitionChild>
              </div>
            </div>
          </Dialog>
        </TransitionRoot>

</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { defineProps, reactive, defineEmits, watch, ref, onMounted } from 'vue';


const props = defineProps({
    open: { type: Boolean, optional: false },
    art: { type: String, optional: false },
    formdata: { type: Object, optional: true},
    mode: { type: String, optional: false },
  })
const emits = defineEmits(['getdata', 'close'])
const openit = ref(false)
const form = reactive({ title: 'Foo', type: 'Link', link: 'https://foo.bar' })


const emittr = () => {
  const data = { data: form, art: props.art, mode:props.mode }
    emits('getdata', data)
}

watch(() => props.open, (val) => {
  openit.value = val
})

onMounted( () => {
  if(props.formdata !== undefined) {
  watch(props.formdata, (val) => {
    form.title = val.title
    form.link = val.link
    form.type = val.type
  })
}
})



const closeit = val => {
  openit.value = false
  emits('close', val)
}
//watch(openit, (val) => console.log(val))
</script>